import { arePdfCoverFilterPageCheckboxesEnabled, getCurrentOrgId, isOrgUiEnabled, isSpotterModelSectionHiddenInAdminPortal, } from '@thoughtspot/session-service';
import { CONTEXT } from './common';
export const getViewMode = (currentOrgId) => {
    if (isOrgUiEnabled() && getCurrentOrgId() === 0) {
        if (currentOrgId === -1) {
            return CONTEXT.ALL.view_mode;
        }
        if (currentOrgId === 0) {
            return CONTEXT.PRIMARY.view_mode;
        }
    }
    return CONTEXT.NONE.view_mode;
};
export const getConfigVisibilityRules = () => [
    {
        configName: 'orion.arePdfCoverFilterPageDefaultsChecked',
        isHidden: !arePdfCoverFilterPageCheckboxesEnabled(),
    },
];
export const isConfigurationVisible = (configName) => {
    const rules = getConfigVisibilityRules();
    const rule = rules.find(r => r.configName === configName);
    return !rule || !rule.isHidden;
};
export const getSettingVisibilityRules = () => [
    {
        settingName: 'spotterModel',
        isHidden: isSpotterModelSectionHiddenInAdminPortal(),
    },
];
export const isSettingVisible = (settingName) => {
    const rules = getSettingVisibilityRules();
    const rule = rules.find(r => r.settingName === settingName);
    return !rule || !rule.isHidden;
};
//# sourceMappingURL=settings.container.util.js.map